import { useTranslation } from 'react-i18n-lite'

import Icon from '~/components/Icon'

import { CustomHeightClass } from '~/components/Icon/type'

import { VisibilityIcon } from '../styles'

type Props = {
  showingPassword: boolean
  onTrigger: () => void
  iconSize?: CustomHeightClass
}

const PasswordVisibilityIcon = ({
  showingPassword,
  onTrigger,
  iconSize = 'regular'
}: Props) => {
  const { t } = useTranslation()

  const iconName = showingPassword
    ? 'EyeSignForOptionalVisibility'
    : 'EyeSignForOptionalInvisibility'

  const ariaLabel = t(
    showingPassword
      ? 'navigation-slider.hidePassword'
      : 'navigation-slider.showPassword'
  )

  return (
    <VisibilityIcon
      type='button'
      aria-label={ariaLabel}
      title={ariaLabel}
      tabIndex={0}
      onClick={onTrigger}
    >
      <Icon iconName={iconName} icSize={iconSize} />
    </VisibilityIcon>
  )
}

export default PasswordVisibilityIcon
